import React, { Component } from 'react';
// import Immutable from 'immutable';

let $ = window.jQuery;
let moment = window.moment;
export default class Scheduler extends Component {
    state = {
        resources: [],
        events: []
    };

    initCalendar = () => {
        if (!$.fullCalendar) {
            return;
        }

        $('#schedulerCalendar').fullCalendar({
            schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
            defaultView: 'agendaDay',
            editable: true,
            selectable: true,
            eventLimit: true, // allow "more" link when too many events
            minTime: '05:00:00',
            maxTime: '23:00:00',
            slotDuration: '00:15:00',
            eventColor: '#F1C40F',
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'agendaDay,agendaTwoDay,agendaWeek,month'
            },
            views: {
                agendaTwoDay: {
                    type: 'agenda',
                    duration: { days: 2 },

                    // views that are more than a day will NOT do this behavior by default
                    // so, we need to explicitly enable it
                    groupByResource: true

                    //// uncomment this line to group by day FIRST with resources underneath
                    //groupByDateAndResource: true
                }
            },

            //// uncomment this line to hide the all-day slot
            //allDaySlot: false,

            resources: this.state.resources,
            // events: [
            //     { id: '1', resourceId: 'a', start: '2016-09-06', end: '2016-09-08', title: 'event 1',  },
            //     { id: '2', resourceId: 'a', start: '2016-09-07T09:00:00', end: '2016-09-07T09:30:00', title: 'event 2' },
            //     { id: '3', resourceId: 'b', start: '2016-09-07T12:00:00', end: '2016-09-07T13:00:00', title: 'event 3' },
            //     { id: '4', resourceId: 'c', start: '2016-09-07T07:30:00', end: '2016-09-07T09:30:00', title: 'event 4' },
            //     { id: '5', resourceId: 'd', start: '2016-09-07T10:00:00', end: '2016-09-07T11:00:00', title: 'event 5' }
            // ],
            events: this.state.events,

            select: function(start, end, jsEvent, view, resource) {
                console.log(
                    'select',
                    start.format(),
                    end.format(),
                    resource ? resource.id : '(no resource)'
                );
            },
            dayClick: function(date, jsEvent, view, resource) {
                console.log(
                    'dayClick',
                    date.format(),
                    resource ? resource.id : '(no resource)'
                );
            }
        });
    };

    parseResources = () => {
        let resources = [...this.props.dentists];

        let results = [];
        for (let resource of resources) {
            results.push({
                id: resource.value,
                title: resource.label
            });
        }

        this.setState({
            resources: results
        }, () => {
            this.parseEvents();
        })
    };

    parseEvents = () => {
        let keys = Object.keys(this.props.appointments);
        let events = this.props.appointments;


        let results = [];
        for (let day of keys) {
            for (let event of events[day]) {
                if (! event.patient) {
                    continue;
                }

                let patientName = event.patient.firstname + " " + event.patient.lastname;
                let startDate = moment(event.appointment_date + " " + event.start_time);
                let endDate = moment(event.appointment_date + " " + event.end_time);
                let color = '#F1C40F';

                switch (event.status) {
                    case 'completed':
                        color = '#337ab7';
                        break;
                    case 'cancelled':
                        color = '#ed6b75';
                        break;
                    default:
                        color = '#F1C40F';
                }

                // eslint-disable-next-line
                let title = "Patient Name: " + patientName + "\n" + "Chair Number: " + event.chair_number + "\n" + event.remarks;

                results.push({
                    id: event.appointment_id,
                    resourceId: event.practitioner_id,
                    start: startDate.format(),
                    end:  endDate.format(),
                    title: title,
                    color: color
                })
            }
        }

        this.setState({
            events: results
        }, () => {
            this.initCalendar();
        })
    };

    componentDidMount() {
        this.parseResources();
    }

    render() {
        return (
            <div className="col-md-12 col-lg-12 col-sm-12" style={{ height: '80%'}}>
                <div id="schedulerCalendar" className="has-toolbar"> </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Calendar/Scheduler.js
 **/